import { createContext, default as React } from 'react'

export const AccountContext = createContext<number | null>(null)

export default AccountContext
